module.exports = __webpack_public_path__ + "img/emt_days_change_pwd.ddd1c8ac.png";